/* KLARHEIT 2027 — cart drawer enhancements.
   Delegated listeners so they survive Dawn's section re-renders. */
(function () {
  document.addEventListener('click', function (e) {
    // Staffel-Zeile: round quantity up to the next full tier
    var tier = e.target.closest('[data-k27-tier-add]');
    if (tier) {
      e.preventDefault();
      var line = tier.getAttribute('data-line');
      var input = document.getElementById('Drawer-quantity-' + line);
      if (input) {
        input.value = tier.getAttribute('data-target-qty');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // Rabattcode: toggle input row
    var toggle = e.target.closest('[data-k27-code-toggle]');
    if (toggle) {
      e.preventDefault();
      var row = toggle.parentNode.querySelector('.code-row');
      if (row) {
        row.hidden = !row.hidden;
        if (!row.hidden) {
          var input = row.querySelector('input');
          if (input) input.focus();
        }
      }
      return;
    }

    // Rabattcode: apply via Shopify discount URL, then on to checkout
    var apply = e.target.closest('[data-k27-code-apply]');
    if (apply) {
      e.preventDefault();
      var codeInput = apply.parentNode.querySelector('[data-k27-code-input]');
      var code = codeInput ? codeInput.value.trim() : '';
      if (code) {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      }
    }
  });

  // Enter key in code input applies
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-k27-code-input]')) {
      e.preventDefault();
      var btn = e.target.parentNode.querySelector('[data-k27-code-apply]');
      if (btn) btn.click();
    }
  });

  /* =============================================================
     Farbe je Buch (KLARHEIT 8 / AIR), seit 2026-10.
     Das Markup kommt aus snippets/cart-drawer.liquid (.ci-colors):
     eine Zeile pro Buch ([data-cc-row], data-cur = Variante), darin
     ein Knopf pro Farbe ([data-k27-color], data-to = Variante) und die
     Daten der Varianten als JSON ([data-cc-data]).
     Ein Klick verschiebt genau ein Stück von der bisherigen zur
     gewählten Variante: EIN Aufruf von /cart/update.js, danach wird
     der Warenkorb neu gezeichnet (wie Dawn nach einer Mengenänderung:
     .drawer__inner + cart-icon-bubble).
     Farben sind eigene Warenkorb-Zeilen; der Shop sortiert sie selbst.
     Damit "Buch 2" nach dem Wechsel "Buch 2" bleibt, merkt sich die
     Seite die Reihenfolge der Bücher (sessionStorage) und ordnet die
     Zeilen nach jedem Neuzeichnen wieder so an.
     ============================================================= */
  var SLOT_KEY = 'k27-color-slots';
  var colorBusy = false;

  function readSlots() {
    try { return JSON.parse(window.sessionStorage.getItem(SLOT_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeSlots(slots) {
    try { window.sessionStorage.setItem(SLOT_KEY, JSON.stringify(slots)); } catch (e) {}
  }
  function blockData(block) {
    try { return JSON.parse(block.querySelector('[data-cc-data]').textContent) || []; } catch (e) { return []; }
  }
  function rowsOf(block) {
    return Array.prototype.slice.call(block.querySelectorAll('[data-cc-row]'));
  }

  // Zeilen eines Blocks in die gemerkte Reihenfolge bringen (einmal pro Zeichnung).
  function arrange(block) {
    if (block.hasAttribute('data-cc-arranged')) return;
    block.setAttribute('data-cc-arranged', '');
    var handle = block.getAttribute('data-k27-colors');
    var rows = rowsOf(block);
    var byId = {};
    blockData(block).forEach(function (v) { byId[v.id] = v; });
    var left = {};
    rows.forEach(function (r) {
      var c = r.getAttribute('data-cur');
      left[c] = (left[c] || 0) + 1;
    });
    var slots = readSlots();
    var next = [];
    (slots[handle] || []).forEach(function (id) {
      id = String(id);
      if (next.length < rows.length && left[id] > 0) { next.push(id); left[id] -= 1; }
    });
    rows.forEach(function (r) {
      var c = r.getAttribute('data-cur');
      if (left[c] > 0) { next.push(c); left[c] -= 1; }
    });
    rows.forEach(function (r, i) {
      var cur = next[i];
      if (!cur || cur === r.getAttribute('data-cur')) return;
      r.setAttribute('data-cur', cur);
      var name = r.querySelector('[data-cc-name]');
      if (name && byId[cur]) name.textContent = byId[cur].name;
      Array.prototype.forEach.call(r.querySelectorAll('[data-k27-color]'), function (b) {
        var to = b.getAttribute('data-to');
        var on = to === cur;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.disabled = !on && !!byId[to] && !byId[to].available;
      });
    });
    slots[handle] = next;
    writeSlots(slots);
  }
  function arrangeAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-k27-colors]'), arrange);
  }

  function renderDrawer(sections) {
    var pick = function (html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    };
    var scroller = document.querySelector('cart-drawer-items');
    var top = scroller ? scroller.scrollTop : 0;
    var fresh = sections['cart-drawer'] ? pick(sections['cart-drawer'], '.drawer__inner') : null;
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (fresh && inner) inner.innerHTML = fresh.innerHTML;
    var bubble = document.getElementById('cart-icon-bubble');
    var freshBubble = sections['cart-icon-bubble'] ? pick(sections['cart-icon-bubble'], '.shopify-section') : null;
    if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
    scroller = document.querySelector('cart-drawer-items');
    if (scroller && top) scroller.scrollTop = top;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-k27-color]') : null;
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-cc-row]');
    var block = btn.closest('[data-k27-colors]');
    if (!row || !block || colorBusy || btn.disabled) return;
    var from = row.getAttribute('data-cur');
    var to = btn.getAttribute('data-to');
    if (!from || !to || from === to) return;

    var vFrom = null, vTo = null;
    blockData(block).forEach(function (v) {
      if (v.id === from) vFrom = v;
      if (v.id === to) vTo = v;
    });
    var err = block.querySelector('[data-cc-err]');
    function fail(message) {
      if (!err) return;
      err.textContent = message || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
      err.hidden = false;
    }
    if (err) { err.hidden = true; err.textContent = ''; }
    if (!vFrom || !vTo || !vFrom.key || vFrom.lineQty < 1) { fail(''); return; }
    if (!vTo.available) { fail(vTo.name + ' ist gerade ausverkauft.'); return; }

    // Ein Stück weniger von der alten Farbe, eins mehr von der neuen, in einem Aufruf.
    var updates = {};
    updates[vFrom.key] = vFrom.lineQty - 1;
    updates[vTo.key || vTo.id] = (vTo.key ? vTo.lineQty : 0) + 1;

    var handle = block.getAttribute('data-k27-colors');
    var rowIndex = Number(row.getAttribute('data-cc-row'));
    var order = rowsOf(block).map(function (r) { return r.getAttribute('data-cur'); });
    order[rowIndex] = to;

    // Sofort zeigen, was gewählt wurde. Der Warenkorb zieht im Hintergrund nach;
    // schlägt der Aufruf fehl, springt die Zeile auf die alte Farbe zurück.
    var nameEl = row.querySelector('[data-cc-name]');
    function paint(cur, name) {
      row.setAttribute('data-cur', cur);
      if (nameEl) nameEl.textContent = name;
      Array.prototype.forEach.call(row.querySelectorAll('[data-k27-color]'), function (b) {
        var on = b.getAttribute('data-to') === cur;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    paint(to, vTo.name);

    colorBusy = true;
    block.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d || {} }; }); })
      .then(function (res) {
        var d = res.d;
        if (!res.ok || d.status || !d.sections || !d.sections['cart-drawer']) {
          paint(from, vFrom.name);
          fail(d.description || d.message || '');
          return;
        }
        var slots = readSlots();
        slots[handle] = order;
        writeSlots(slots);
        renderDrawer(d.sections);
        arrangeAll();
        var again = document.querySelector('[data-k27-colors="' + handle + '"] [data-cc-row="' + rowIndex + '"] [data-to="' + to + '"]');
        if (again) again.focus();
      })
      .catch(function () { paint(from, vFrom.name); fail(''); })
      .then(function () {
        colorBusy = false;
        var current = document.querySelector('[data-k27-colors="' + handle + '"]');
        if (current) current.removeAttribute('aria-busy');
        block.removeAttribute('aria-busy');
      });
  });

  // Nach jedem Neuzeichnen des Warenkorbs (Dawn, k27-gift.js, Kaufbox) die Reihenfolge wiederherstellen.
  function watchColors() {
    arrangeAll();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var timer = null;
    new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () { timer = null; arrangeAll(); }, 0);
    }).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchColors);
  else watchColors();
})();
